import { GitBranch, GitOrganization, GitProject, GitRepository } from "@supernova-studio/model";
import { DTOGitBranch, DTOGitOrganization, DTOGitProject, DTOGitRepository } from "../../dto";

export function gitOrganizationToDto(org: GitOrganization): DTOGitOrganization {
  return {
    id: org.id,
    name: org.name,
    url: org.url,
    slug: org.slug,
  };
}

export function gitProjectToDto(project: GitProject): DTOGitProject {
  return {
    id: project.id,
    name: project.name,
    url: project.url,
    slug: project.slug,
  };
}

export function gitRepositoryToDto(repo: GitRepository): DTOGitRepository {
  return {
    id: repo.id,
    name: repo.name,
    url: repo.url,
    slug: repo.slug,
    defaultBranch: repo.defaultBranch,
  };
}

export function gitBranchToDto(branch: GitBranch): DTOGitBranch {
  return {
    name: branch.name,
    lastCommitId: branch.lastCommitId,
  };
}
